module.exports = __webpack_public_path__ + "img/lordbekket_snowman.f80caab8.jpg";